import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeKatex from "rehype-katex";
import remarkMath from "remark-math";
import rehypeRaw from "rehype-raw";

function PageContent(props: any) {
  return (
    <div className="flex w-full px-[24px] md:px-[70px] justify-center items-center">
      <div
        className="flex justify-center items-center mx-auto flex-col md:max-w-[1500px] gap-[30px] py-[50px]"
        id="page-content"
      >
        <ReactMarkdown
          className={"prose"}
          remarkPlugins={[remarkMath]}
          rehypePlugins={[rehypeKatex, rehypeRaw]}
        >
          {props.children}
        </ReactMarkdown>
      </div>
    </div>
  );
}

export default PageContent;
